// removed by extract-text-webpack-plugin
module.exports = {"root":"ItemBannerNew--root--2I","icon":"ItemBannerNew--icon--2b","body":"ItemBannerNew--body--2h","bodyEmblem":"ItemBannerNew--bodyEmblem--ee ItemBannerNew--body--2h","main":"ItemBannerNew--main--2A","sub":"ItemBannerNew--sub--3U","itemName":"ItemBannerNew--itemName--VJ","close":"ItemBannerNew--close--3X","exotic":"ItemBannerNew--exotic--bp","legendary":"ItemBannerNew--legendary---8","rare":"ItemBannerNew--rare--3U","common":"ItemBannerNew--common--1K","basic":"ItemBannerNew--basic--sp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemBannerNew/styles.styl
// module id = 839
// module chunks = 0